
        import { adapter, enhanceGlobals } from 'next/dist/esm/server/web/adapter'

        enhanceGlobals()

        var mod = require("private-next-root-dir/middleware.ts")
        var handler = mod.middleware || mod.default;

        if (typeof handler !== 'function') {
          throw new Error('The Middleware "pages/middleware" must export a `middleware` or a `default` function');
        }

        export default function (opts) {
          return adapter({
              ...opts,
              page: "/middleware",
              handler,
          })
        }
    